<template>
  <div class="loginForm">
    <v-card class="mx-auto" max-width="95%">
			<v-list-item-title class="headline mb-1" v-if="this.topic !== 'ACCESSIBILITY'">
				Contact Us
				<h1 class="d-sr-only">Contact Us</h1>
			</v-list-item-title>
			<v-list-item-title class="headline mb-1" v-if="this.topic === 'ACCESSIBILITY'">
				ASA24 Accessibility Feedback Form
				<h1 class="d-sr-only">ASA24 Accessibility Feedback Form</h1>
			</v-list-item-title>
      <v-divider></v-divider>
			<v-card-subtitle> Fields marked with * are required.</v-card-subtitle>
      <div>
        <v-form ref="form" align="center" v-model="valid">
          <v-text-field
						ref="firstFocusable"
            v-model="firstName"
            label="*First Name"
            :rules="firstNameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            label="*Last Name"
            :rules="lastNameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="organization"
            label="*Organization"
            :rules="organizationRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="phoneNumber"
            label="Phone Number"
          ></v-text-field>
          <v-text-field
            v-model="email"
            label="*Email"
            :rules="emailRules"
            required
          ></v-text-field>
						<div v-if="this.topic !== 'ACCESSIBILITY'">
						<v-select
						:items="studyObjects"
						item-text="studyNames"
						item-value="studyObjs"
						label="Select a Study"
						v-model="studyInfo"
						v-if="this.userInfo.firstName && studyObjects && studyObjects.length > 0"
						>
						</v-select>
						<v-text-field
						v-else
						v-model="studyFromText"
            label="Study Name"
          ></v-text-field>
						</div>
					<v-select
						v-model="topic"
						:items="topics"
						label="*Topic"
						item-text="htmlText"
          	item-value="trueValue"
						required
						:rules="topicRules"
						item-color="black"
					>
					</v-select>
					<!-- (below) section if the topic is "Report a Bug" -->
					<div v-if="this.topic=='BUG'">
					<p>This bug is found on the:</p>
					<v-select
					label="*Select a Web site"
					v-model="website"
					:items="websites"
					item-text="htmlText"
          item-value="trueValue"
					required
					:rules="websiteRules"
					item-color="black"
					>
					</v-select>
					<p>Which version of ASA24 are you using?</p>
					<v-select
						label="*Select a version of ASA24"
						v-model="version"
						:items="versions"
						item-text="htmlText"
						item-value="trueValue"
						required
						:rules="versionRules"
						item-color="black"
						>
					</v-select>
					<p>What is the operating system of the computer being used to access ASA24?</p>
					<v-select
						label="Select an operating system"
						v-model="opSystem"
						:items="opSystems"
						item-text="htmlText"
						item-value="trueValue"
						item-color="black"
						>
					</v-select>
					<p>What browser is being used to access ASA24?</p>
					<v-select
						label="Select a browser"
						v-model="browser"
						:items="browsers"
						item-text="htmlText"
						item-value="trueValue"
						item-color="black"
						>
					</v-select>
					</div>
					<!-- (above) section if the topic is "Report a Bug" -->
					<!-- (below) section if the topic is "Need Help With ASA24" -->
					<div v-if="this.topic=='HELP'">
					<p>Which version of ASA24 are you using?</p>
					<v-select
					label="*Select a version of ASA24"
						v-model="version"
						:items="versions"
						item-text="htmlText"
						item-value="trueValue"
						required
						:rules="versionRules"
						item-color="black"
					>
					</v-select>
					<p>Name of a researcher or staff member with an ASA24 Researcher Web site account</p>
					<v-text-field label="Researcher Name" v-model="staffName">
					</v-text-field>
					<p>Researcher/staff member's e-mail address</p>
					<v-text-field label="Researcher Email" v-model="staffEmail">
					</v-text-field>
					<v-select
						label="*What would you like help with"
						v-model="suggestion"
						:items="suggestions"
						item-text="htmlText"
						item-value="trueValue"
						required
						:rules="suggestionRules"
						item-color="black"
					>
					</v-select>
					</div>
					<!-- (above) section if the topic is "Need Help With ASA24" -->
					<v-textarea
					name="input-7-1"
					v-model="emailMessage"
          label="*Email Message"
					:rules="emailTextRules"
					required
        ></v-textarea>
				<div v-if="this.topic !== 'ACCESSIBILITY'">
				<v-file-input
					truncate-length="10"
					label="Attachment"
					v-model="attachment"
					:rules="attachmentRules"
					>
				</v-file-input>
				</div>
          <v-btn @click="canceledForm">Cancel</v-btn>
          <v-btn @click="submitForm" class="btn-default" text :disabled="!valid" :loading="isSubmitting">
            Submit
          </v-btn>
					<v-overlay v-model="saveSuccess"
>
					<v-alert
				class="edit-alert"
				dismissible
				type="success"
				@click="saveSuccess = false"
			>
				Submitted
			</v-alert>
			</v-overlay>
        </v-form>
      </div>
    </v-card>
  </div>
</template>

<script>

import { researcherApiService } from '@/services/researcherApiService.js';

export default {
	name: 'ContactForm',
	data: () => ({
		valid: true,
		firstName: null,
		lastName: null,
		organization: null,
		phoneNumber: null,
		email: null,
		firstNameRules: [(v) => !!v || 'First Name is required'],
		lastNameRules: [(v) => !!v || 'Last Name is required'],
		organizationRules: [(v) => !!v || 'Organiation is required'],
		emailRules: [
			(v) => !!v || 'E-mail is required',
			(v) => /.+@.+/.test(v) || 'E-mail must be valid email format'
		],
		emailTextRules: [(v) => !!v || 'E-mail Text is required'],
		websiteRules: [(v) => !!v || 'Web Site is required'],
		versionRules: [(v) => !!v || 'Version of ASA24 is required'],
		suggestionRules: [(v) => !!v || 'Help Topic is required'],
		topicRules: [(v) => !!v || ' Topic is required'],
		attachmentRules: [(v) => !v || v.size < 5242880 || 'Attachments must be smaller than 5MB'],
		topics: null,
		topic: null,
		studyFromText: null,
		studiesObjectList: [],
		website: null,
		websites: null,
		version: null,
		versions: null,
		opSystem: null,
		opSystems: null,
		browser: null,
		browsers: null,
		suggestion: null,
		suggestions: null,
		emailMessage: null,
		staffName: null,
		staffEmail: null,
		attachment: null,
		saveSuccess: false,
		studyUuid: null,
		studyInfo: null,
		myStudyName: null,
		isSubmitting: false
	}),
	props: {
		preselectTopic: String
	},
	beforeMount () {
		this.firstName = this.userInfo.firstName;
		this.lastName = this.userInfo.lastName;
		this.organization = this.userInfo.organization;
		this.phoneNumber = this.userInfo.phoneNumber;
		this.email = this.userInfo.email;
		this.topics = this.$contactList.contactTopics
		this.websites = this.$contactList.contactWebsites
		this.versions = this.$contactList.contactVersionTypes
		this.opSystems = this.$contactList.contactOperatingSystems
		this.browsers = this.$contactList.contactBrowsers
		this.suggestions = this.$contactList.contactHelpTopics
		this.topic = this.preselectTopic
		this.studiesObjectList = this.studyObjects
		this.studyInfo = this.studiesObjectList[0].studyObjs || null;
	},
	mounted () {
		this.$refs.firstFocusable.focus();
	},
	methods: {
		canceledForm () {
			const me = this;
			me.$router.push('/landing');
		},
		submitForm () {
			this.isSubmitting = true;
			const me = this;
			if (this.studyInfo) {
				this.studyUuid = this.studyInfo.id
			}
			const submitObj = {
				firstName: this.firstName,
				lastName: this.lastName,
				organization: this.organization,
				phoneNumber: this.phoneNumber,
				email: this.email,
				studyName: (this.studyFromText || (this.studyInfo !== null ? this.studyInfo.name : null)),
				studyUuid: this.studyUuid,
				staffMemberEmail: this.staffEmail,
				message: this.emailMessage,
				topic: this.topic,
				website: this.website,
				versionType: this.version,
				operatingSystem: this.opSystem,
				browser: this.browser,
				staffName: this.staffName,
				// staffEmail: this.staffEmail,
				helpTopic: this.suggestion
			}
			researcherApiService.contact(submitObj, this.attachment).then(function (response) {
				me.isSubmitting = false;
				me.$store.dispatch('changeUpdateStatus', { status: 'contact-success' });
				me.$router.push('/landing');
			}).catch(function (error) {
				me.isSubmitting = false;
				let errorMessage = 'There was an error submitting the Contact Us form.'

				if (error.response && error.response.status === 413) {
					// 413 Payload Too Large
					errorMessage = 'The file you are trying to upload is too large. Please try a smaller file.';
				}

				me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'contact-error', message: errorMessage });
			});
		}
	},
	computed: {
		studies: function () {
			return this.$store.getters.getStudies;
		},
		userInfo: function () {
			return this.$store.getters.getUserInfo;
		},
		studyObjects: function () {
			return this.$store.getters.getStudyObjects;
		}
	}
};
</script>

<style>
.v-text-field,
.v-btn {
  margin: 10px;
}
</style>
